enum AboutNavId {
  WhoWeAre = 'who-we-are',
  OurValues = 'our-values',
  OurCulture = 'our-culture',
  GivingBack = 'giving-back'
}

export { AboutNavId };
